import React from 'react';
import { Link } from 'react-router-dom';

const Mail: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <a href="mailto:contact@i-think-its-you.at">{children}</a>
);

export const TermsGerman: React.FC = () => (
  <>
    <p>
      <em>Stand: Mai 2026</em>
    </p>

    <h2>1. Anbieter, Geltungsbereich, Kontaktstellen</h2>
    <p>
      <strong>1.1</strong> Diese Nutzungsbedingungen regeln die Nutzung der Website, mobiler
      Anwendungen und sonstiger digitaler Dienste von I Think It´s You, handelnd unter I Think
      It´s You und Event Partner Austria Verein (&quot;wir&quot;, &quot;uns&quot;,
      &quot;unser&quot;), soweit diese auf diese Nutzungsbedingungen verweisen.
    </p>
    <p>
      <strong>1.2</strong> Anbieter ist:
      <br />
      Event Partner Austria Verein
      <br />
      Kwizdastrasse 9/11
      <br />
      2100 Korneuburg
      <br />
      Österreich
      <br />
      E-Mail: <Mail>contact@i-think-its-you.at</Mail>
      <br />
      Kontaktformular: <Link to="/contact">Kontaktformular</Link>
      <br />
      Impressum: <Link to="/imprint">Impressum</Link>
    </p>
    <p>
      <strong>1.3</strong> Kontaktstelle für Nutzer nach dem Digital Services Act (DSA):
      E-Mail/Formular: <Mail>contact@i-think-its-you.at</Mail>
    </p>
    <p>
      <strong>1.4</strong> Kontaktstelle für Behörden nach dem DSA: E-Mail:{' '}
      <Mail>contact@i-think-its-you.at</Mail>
    </p>
    <p>
      <strong>1.5</strong> Gesetzlicher Vertreter in der Europäischen Union: Falls wir keine
      Niederlassung in der Europäischen Union haben, benennen wir einen gesetzlichen Vertreter
      in einem EU-Mitgliedstaat: [Name/Firma, Anschrift, E-Mail]
    </p>
    <p>
      <strong>1.6</strong> Diese Nutzungsbedingungen können gespeichert und ausgedruckt werden.
      Vertragssprache ist Deutsch. Sofern wir eine Übersetzung bereitstellen, ist bei
      Widersprüchen für diese Fassung die deutsche Version maßgeblich.
    </p>

    <h2>2. Beschreibung des Dienstes und Zustandekommen des Nutzungsvertrags</h2>
    <p>
      <strong>2.1</strong> I Think It´s You ist ein Online-Dienst, über den volljährige
      Nutzerinnen und Nutzer verpasste Begegnungen (&quot;missed connections&quot;)
      beschreiben, veröffentlichen, suchen und – soweit angeboten – über die Plattform Kontakt
      anbahnen können.
    </p>
    <p>
      <strong>2.2</strong> Der Nutzungsvertrag kommt zustande, wenn Sie diese
      Nutzungsbedingungen akzeptieren und wir Ihr Konto freischalten oder Ihnen die
      registrierungspflichtige Nutzung ermöglichen. Für rein öffentlich zugängliche Bereiche
      gelten diese Nutzungsbedingungen ab Beginn der Nutzung der jeweiligen Funktion.
    </p>
    <p>
      <strong>2.3</strong> Soweit einzelne Funktionen oder Zusatzleistungen gesonderten
      Bedingungen unterliegen, informieren wir hierüber vor deren Nutzung gesondert.
    </p>
    <p>
      <strong>2.4</strong> Ein Anspruch auf die dauerhafte Bereitstellung bestimmter Funktionen
      besteht nicht. Abschnitt 15 bleibt unberührt.
    </p>

    <h2>3. Nutzungsberechtigung</h2>
    <p>
      <strong>3.1</strong> Sie dürfen unseren Dienst nur nutzen, wenn Sie mindestens 18 Jahre
      alt und nach dem auf Sie anwendbaren Recht zur Nutzung digitaler Dienste berechtigt sind.
    </p>
    <p>
      <strong>3.2</strong> Die Nutzung durch Personen unter 18 Jahren ist untersagt.
    </p>
    <p>
      <strong>3.3</strong> Sie dürfen nur ein Konto für sich selbst anlegen, sofern wir nicht
      ausdrücklich mehrere Konten gestatten.
    </p>

    <h2>4. Registrierung, Konto und Zugangssicherheit</h2>
    <p>
      <strong>4.1</strong> Bei der Registrierung müssen Sie zutreffende, aktuelle und
      vollständige Angaben machen und diese bei Änderungen aktualisieren.
    </p>
    <p>
      <strong>4.2</strong> Sie sind verpflichtet, Ihre Zugangsdaten vertraulich zu behandeln und
      gegen unbefugten Zugriff zu schützen.
    </p>
    <p>
      <strong>4.3</strong> Sie müssen uns unverzüglich informieren, wenn Sie den Verdacht haben,
      dass Ihr Konto unbefugt genutzt wird.
    </p>
    <p>
      <strong>4.4</strong> Benutzernamen, Profiltexte oder sonstige Kennzeichen dürfen keine
      Rechte Dritter verletzen, keine Person vortäuschen und nicht beleidigend, diskriminierend
      oder irreführend sein. Wir dürfen solche Angaben nach Maßgabe dieser Nutzungsbedingungen
      beanstanden, sperren oder anpassen.
    </p>

    <h2>5. Unsere Rolle als Plattform</h2>
    <p>
      <strong>5.1</strong> Wir stellen die technische Plattform für Nutzerbeiträge und
      Kontaktanbahnungen bereit. Wir sind keine Partnervermittlung, keine Dating-Agentur, keine
      Garantiegeberin für Gegenseitigkeit oder Erfolg und grundsätzlich nicht Partei
      persönlicher Kontakte, Treffen oder sonstiger Vereinbarungen zwischen Nutzerinnen und
      Nutzern.
    </p>
    <p>
      <strong>5.2</strong> Wir führen keine allgemeinen Identitäts-, Hintergrund- oder
      Sicherheitsprüfungen durch, soweit wir dies nicht ausdrücklich angeben.
    </p>
    <p>
      <strong>5.3</strong> Treffen, Nachrichten, Kontaktaufnahmen oder sonstige Interaktionen
      mit anderen Personen erfolgen auf eigene Verantwortung. Bitte handeln Sie vorsichtig und
      respektieren Sie Grenzen anderer Personen.
    </p>

    <h2>6. Öffentliche Sichtbarkeit und Schutz der Privatsphäre</h2>
    <p>
      <strong>6.1</strong> Beiträge in öffentlichen Bereichen des Dienstes können für andere
      Nutzerinnen und Nutzer sichtbar sein. Soweit technisch nicht ausgeschlossen, können
      öffentliche Inhalte auch außerhalb der Plattform wahrgenommen, verlinkt oder indexiert
      werden.
    </p>
    <p>
      <strong>6.2</strong> Veröffentlichen Sie nur Inhalte, die Sie öffentlich teilen dürfen und
      möchten.
    </p>
    <p>
      <strong>6.3</strong> Beschreiben Sie verpasste Begegnungen so, dass die Situation
      erkennbar ist, ohne unnötig in die Privatsphäre anderer Personen einzugreifen.
    </p>
    <p>
      <strong>6.4</strong> Zulässig sind insbesondere zurückhaltende Kontextangaben wie
      ungefähre öffentliche Orte, ein Zeitfenster und äußerlich erkennbare Umstände, soweit dies
      verhältnismäßig ist. Unzulässig sind insbesondere genaue Wohnadressen, private
      Kontaktangaben oder andere Angaben, die eine Person unmittelbar identifizierbar oder
      auffindbar machen.
    </p>

    <h2>7. Verhaltensregeln und verbotene Inhalte</h2>
    <p>
      <strong>7.1</strong> Sie dürfen unseren Dienst nur rechtmäßig, redlich und im Einklang mit
      diesen Nutzungsbedingungen nutzen.
    </p>
    <p>
      <strong>7.2</strong> Insbesondere dürfen Sie nicht:
    </p>
    <ol type="a">
      <li>
        personenbezogene Daten Dritter veröffentlichen, die für den Zweck der
        Begegnungsbeschreibung nicht erforderlich sind;
      </li>
      <li>
        genaue Wohn- oder Arbeitsadressen, Telefonnummern, E-Mail-Adressen, Ausweis- oder
        Kontodaten, Kennzeichen, Buchungsdaten, Social-Media-Handles oder andere direkt
        identifizierende Angaben Dritter ohne deren ausdrückliche Einwilligung veröffentlichen;
      </li>
      <li>
        Fotos, Videos, Audioaufnahmen, Screenshots oder sonstige Abbildungen identifizierbarer
        Personen ohne deren Einwilligung veröffentlichen;
      </li>
      <li>Inhalte über Minderjährige einstellen oder Minderjährige gezielt kontaktieren;</li>
      <li>
        besondere Kategorien personenbezogener Daten Dritter offenlegen, insbesondere zu
        Gesundheit, ethnischer Herkunft, Religion, politischen Ansichten, biometrischen
        Merkmalen, Sexualleben oder sexueller Orientierung;
      </li>
      <li>
        andere Personen belästigen, verfolgen, einschüchtern, sexuell bedrängen, nötigen oder
        wiederholt unerwünscht kontaktieren;
      </li>
      <li>
        Doxxing betreiben oder versuchen, die Identität einer Person gegen deren Willen
        offenzulegen;
      </li>
      <li>
        ehrverletzende, verleumderische oder sonst unbewiesene Vorwürfe gegen identifizierbare
        Personen verbreiten, insbesondere Behauptungen über Straftaten oder vergleichbar schwere
        Vorwürfe;
      </li>
      <li>Hassrede, diskriminierende Inhalte, Gewaltaufrufe oder Drohungen veröffentlichen;</li>
      <li>
        pornografische, sexuell explizite oder sonst schwer anstößige Inhalte veröffentlichen;
      </li>
      <li>sich als eine andere Person ausgeben oder ein irreführendes Profil führen;</li>
      <li>
        Spam, Massenkontakte, Werbung, kommerzielle Angebote, Kettenbriefe oder sonstige
        unerbetene Kommunikation verbreiten;
      </li>
      <li>Schadsoftware, schädlichen Code oder sonstige technische Angriffe einsetzen;</li>
      <li>
        den Dienst automatisiert in missbräuchlicher Weise nutzen, insbesondere durch Scraping,
        Bots, Data-Mining oder ähnliche Verfahren, soweit dies nicht zwingend gesetzlich
        erlaubt ist;
      </li>
      <li>unsere Sicherheitsmaßnahmen umgehen oder die Funktionsfähigkeit des Dienstes stören;</li>
      <li>
        Standortfunktionen missbrauchen, um Personen nachzuverfolgen, zu überwachen oder unter
        Druck zu setzen.
      </li>
    </ol>
    <p>
      <strong>7.3</strong> Soweit wir Direktnachrichten oder andere Kontaktfunktionen anbieten,
      müssen Sie eine Ablehnung, Nichtreaktion, Blockierung oder sonst erkennbare
      Kontaktunwilligkeit respektieren.
    </p>

    <h2>8. Nutzerbeiträge, Verantwortung und Rechte</h2>
    <p>
      <strong>8.1</strong> &quot;Beiträge&quot; sind alle Inhalte, die Sie im Zusammenhang mit
      dem Dienst einstellen, übermitteln, speichern oder sonst verfügbar machen, insbesondere
      Texte, Bilder, Profilangaben, Nachrichten und Kommentare.
    </p>
    <p>
      <strong>8.2</strong> Sie bleiben Eigentümerin bzw. Eigentümer Ihrer Beiträge. Wir
      beanspruchen kein Eigentum an Ihren Inhalten.
    </p>
    <p>
      <strong>8.3</strong> Sie sichern zu, dass Sie über alle erforderlichen Rechte,
      Einwilligungen und Befugnisse verfügen, um Ihre Beiträge rechtmäßig einzustellen und uns
      die in diesem Abschnitt beschriebenen Nutzungsrechte einzuräumen.
    </p>
    <p>
      <strong>8.4</strong> Sie räumen uns an Ihren Beiträgen eine nicht ausschließliche,
      weltweite, unentgeltliche, unterlizenzierbare Lizenz ein, soweit und solange dies
      erforderlich ist, um den Dienst zu betreiben und bereitzustellen. Dies umfasst
      insbesondere das Hosten, Speichern, technische Vervielfältigen, Formatieren, Anzeigen,
      öffentliche Zugänglichmachen innerhalb des Dienstes, Übertragen, Moderieren, Sichern sowie
      das Verwenden für Missbrauchsprävention, Sicherheit, Fehleranalyse und notwendige
      Weiterentwicklungen des Dienstes.
    </p>
    <p>
      <strong>8.5</strong> Diese Lizenz endet grundsätzlich, wenn Ihr Beitrag gelöscht wird oder
      Ihr Konto endet. Hiervon unberührt bleiben:
    </p>
    <ul>
      <li>Sicherungskopien und technische Zwischenspeicher,</li>
      <li>gesetzliche Aufbewahrungspflichten,</li>
      <li>
        die weitere Speicherung, soweit dies zur Rechtsverteidigung, Missbrauchsprävention oder
        Durchsetzung dieser Nutzungsbedingungen erforderlich ist.
      </li>
    </ul>
    <p>
      <strong>8.6</strong> Wir verwenden Ihre Beiträge nicht für werbliche Zwecke außerhalb des
      Dienstes, es sei denn, Sie haben hierzu gesondert eingewilligt.
    </p>
    <p>
      <strong>8.7</strong> Soweit technische Bearbeitungen erforderlich sind, erklären Sie sich
      mit Formatierungs- und Anpassungshandlungen einverstanden. Eine allgemeine Abtretung oder
      ein pauschaler Verzicht auf Urheberpersönlichkeitsrechte ist damit nicht verbunden.
    </p>

    <h2>9. Meldung rechtswidriger oder regelwidriger Inhalte</h2>
    <p>
      <strong>9.1</strong> Wir stellen ein leicht zugängliches Verfahren zur Meldung mutmaßlich
      rechtswidriger oder gegen diese Nutzungsbedingungen verstoßender Inhalte bereit:{' '}
      <Link to="/contact">Kontaktformular</Link>
      sowie die Meldefunktion in der Anwendung an Beiträgen und Kommentaren.
    </p>
    <p>
      <strong>9.2</strong> Eine Meldung soll nach Möglichkeit enthalten:
    </p>
    <ul>
      <li>
        die genaue Bezeichnung des betroffenen Inhalts (z.&nbsp;B. Link, Beitrags-ID,
        Nutzername),
      </li>
      <li>eine Beschreibung des Problems,</li>
      <li>die Gründe, aus denen Sie den Inhalt für rechtswidrig oder regelwidrig halten,</li>
      <li>gegebenenfalls Unterlagen oder Screenshots,</li>
      <li>Ihre Kontaktmöglichkeit für Rückfragen.</li>
    </ul>
    <p>
      <strong>9.3</strong> Wir prüfen Meldungen sorgfältig und treffen nach pflichtgemäßem
      Ermessen angemessene Maßnahmen. Je nach Sachlage können wir Inhalte entfernen, den Zugang
      beschränken, die Sichtbarkeit reduzieren, Kontaktfunktionen einschränken, Nutzer verwarnen
      oder Konten vorübergehend oder dauerhaft sperren.
    </p>
    <p>
      <strong>9.4</strong> Soweit gesetzlich erforderlich oder sachgerecht, informieren wir
      Betroffene über unsere Entscheidung und deren wesentliche Gründe.
    </p>
    <p>
      <strong>9.5</strong> Wir dürfen Meldungen vertrauenswürdiger Hinweisgeber sowie Meldungen
      in akuten Sicherheitsfällen priorisiert bearbeiten.
    </p>
    <p>
      <strong>9.6</strong> Wir sind nicht verpflichtet, sämtliche Inhalte allgemein proaktiv zu
      überwachen. Wir dürfen jedoch technische und manuelle Maßnahmen einsetzen, um Missbrauch,
      Sicherheitsrisiken und Verstöße gegen diese Nutzungsbedingungen zu erkennen und zu
      begrenzen.
    </p>

    <h2>10. Internes Beschwerdesystem</h2>
    <p>
      <strong>10.1</strong> Wenn wir gegen Ihren Inhalt, Ihr Konto oder Ihre Nutzung des
      Dienstes eine Maßnahme ergreifen oder wenn Sie als meldende Person mit einer Entscheidung
      über Ihre Meldung nicht einverstanden sind, können Sie innerhalb von sechs Monaten nach
      Mitteilung der Entscheidung über unser internes Beschwerdesystem Beschwerde einlegen:{' '}
      <Link to="/contact">Beschwerdeformular (Kontakt)</Link>.
    </p>
    <p>
      <strong>10.2</strong> Das Beschwerdeverfahren ist elektronisch und kostenfrei zugänglich.
    </p>
    <p>
      <strong>10.3</strong> Wir prüfen Beschwerden zeitnah, sorgfältig, diskriminierungsfrei und
      nicht willkürlich. Entscheidungen im Beschwerdeverfahren werden nicht ausschließlich
      automatisiert getroffen.
    </p>
    <p>
      <strong>10.4</strong> Ist Ihre Beschwerde begründet, machen wir die beanstandete Entscheidung
      unverzüglich rückgängig oder passen sie entsprechend an.
    </p>
    <p>
      <strong>10.5</strong> Sie erhalten eine begründete Entscheidung. Gesetzliche Rechte auf
      gerichtlichen Rechtsschutz und auf Inanspruchnahme gesetzlich vorgesehener außergerichtlicher
      Streitbeilegungsstellen bleiben unberührt.
    </p>

    <h2>11. Reihenfolge, Sortierung und Empfehlung von Inhalten</h2>
    <p>
      <strong>11.1</strong> Soweit wir Inhalte sortieren, priorisieren oder empfehlen, verwenden
      wir hierfür die jeweils im Dienst beschriebenen Hauptparameter.
    </p>
    <p>
      <strong>11.2</strong> Die Hauptparameter für die Sortierung oder Empfehlung öffentlicher
      Beiträge sind derzeit insbesondere:
    </p>
    <ul>
      <li>[gewählter Ort / Suchradius],</li>
      <li>[Aktualität des Beitrags],</li>
      <li>[textliche Relevanz zum Suchort oder Suchanliegen],</li>
      <li>[Sprache / Region],</li>
      <li>[Vollständigkeit des Beitrags],</li>
      <li>[Sicherheits-, Qualitäts- oder Moderationssignale],</li>
      <li>[Interaktionssignale, soweit tatsächlich verwendet].</li>
    </ul>
    <p>
      <strong>11.3</strong> Soweit technisch möglich und sinnvoll, stellen wir zusätzlich eine
      nicht oder weniger personalisierte Sortierung bereit, etwa nach Ort oder Aktualität.
    </p>

    <h2>12. Rechte am Dienst und an unseren Kennzeichen</h2>
    <p>
      <strong>12.1</strong> Der Dienst selbst, einschließlich Software, Design, Datenbanken,
      Logos, Marken, Texte und sonstiger Elemente, bleibt unser Eigentum oder das Eigentum
      unserer Lizenzgeber.
    </p>
    <p>
      <strong>12.2</strong> Wir gewähren Ihnen für die Dauer des Nutzungsvertrags ein einfaches,
      nicht übertragbares, widerrufliches Recht, den Dienst im Rahmen dieser Nutzungsbedingungen
      für private oder sonst ausdrücklich erlaubte Zwecke zu nutzen.
    </p>
    <p>
      <strong>12.3</strong> Nicht gestattet sind insbesondere:
    </p>
    <ul>
      <li>das Kopieren, Verkaufen oder gewerbliche Verwerten wesentlicher Teile des Dienstes,</li>
      <li>das missbräuchliche automatisierte Auslesen,</li>
      <li>Reverse Engineering, soweit nicht zwingend gesetzlich erlaubt,</li>
      <li>die Nutzung unserer Kennzeichen ohne unsere vorherige Zustimmung.</li>
    </ul>

    <h2>13. Drittanbieter-Dienste</h2>
    <p>
      <strong>13.1</strong> Der Dienst kann Funktionen oder Inhalte von Drittanbietern einbinden,
      etwa Social-Login-, Karten-, Hosting-, Zahlungs- oder Analyse-Dienste.
    </p>
    <p>
      <strong>13.2</strong> Für Dienste Dritter gelten zusätzlich deren eigene Bedingungen und
      Datenschutzbestimmungen. Wir sind nicht für fremde Websites, Apps oder Inhalte
      verantwortlich, soweit gesetzlich nichts anderes gilt.
    </p>

    <h2>14. Unentgeltliche Nutzung, Spenden und künftige Zusatzleistungen</h2>
    <p>
      <strong>14.1</strong> Soweit nicht ausdrücklich anders ausgewiesen, ist die Nutzung des
      Kerndienstes unentgeltlich.
    </p>
    <p>
      <strong>14.2</strong> Freiwillige Spenden begründen keinen Anspruch auf bestimmte
      Funktionen, auf bevorzugte Behandlung, auf eine bestimmte Verfügbarkeit oder auf die
      Veröffentlichung einzelner Beiträge.
    </p>
    <p>
      <strong>14.3</strong> Die Zahlungsabwicklung für Spenden oder sonstige Zahlungen kann über
      Drittanbieter erfolgen. In diesem Fall können ergänzende Bedingungen des
      Zahlungsdienstleisters gelten.
    </p>
    <p>
      <strong>14.4</strong> Soweit künftig entgeltliche Zusatzleistungen eingeführt werden,
      informieren wir Sie vor Vertragsschluss klar über Preis, Leistungsumfang, Laufzeit,
      Kündigungsbedingungen und gegebenenfalls bestehende Widerrufsrechte.
    </p>

    <h2>15. Verfügbarkeit, Wartung und Änderungen des Dienstes</h2>
    <p>
      <strong>15.1</strong> Wir bemühen uns um eine angemessene Verfügbarkeit des Dienstes. Eine
      ununterbrochene oder fehlerfreie Verfügbarkeit schulden wir jedoch nicht.
    </p>
    <p>
      <strong>15.2</strong> Wir dürfen den Dienst vorübergehend einschränken oder unterbrechen,
      soweit dies für Wartung, Sicherheit, Missbrauchsabwehr, technische Verbesserungen oder aus
      rechtlichen Gründen erforderlich ist.
    </p>
    <p>
      <strong>15.3</strong> Wir dürfen Funktionen ändern, weiterentwickeln oder einstellen, wenn
      dafür ein sachlicher Grund besteht, insbesondere bei Sicherheitsanforderungen,
      Rechtsänderungen, Missbrauch, technischen Änderungen oder berechtigter Weiterentwicklung
      des Angebots.
    </p>
    <p>
      <strong>15.4</strong> Wenn Änderungen sich wesentlich nachteilig auf bereits vereinbarte
      entgeltliche oder fortlaufende Leistungen auswirken, bleiben Ihre zwingenden gesetzlichen
      Rechte unberührt.
    </p>

    <h2>16. Verbraucherinformationen und gesetzliche Rechte</h2>
    <p>
      <strong>16.1</strong> Wenn Sie Verbraucher sind, bleiben Ihre zwingenden gesetzlichen Rechte
      unberührt. Das gilt insbesondere für Rechte in Bezug auf digitale Dienstleistungen,
      Gewährleistung, Vertragsbeendigung, Schadenersatz, Datenschutz und gerichtlichen
      Rechtsschutz.
    </p>
    <p>
      <strong>16.2</strong> Soweit für den Abschluss eines Verbrauchervertrags gesetzliche
      Vorabinformationen oder ein Widerrufsrecht erforderlich sind, stellen wir Ihnen diese
      Informationen vor Vertragsschluss gesondert in der gesetzlich vorgeschriebenen Form zur
      Verfügung.
    </p>
    <p>
      <strong>16.3</strong> Soweit ein gesetzliches Widerrufsrecht besteht und Sie verlangen,
      dass die Leistung vor Ablauf der Widerrufsfrist beginnt, holen wir – soweit gesetzlich
      erforderlich – Ihre gesonderte Zustimmung und erforderliche Bestätigungen ein.
    </p>

    <h2>17. Datenschutz und Cookies</h2>
    <p>
      <strong>17.1</strong> Die Verarbeitung personenbezogener Daten richtet sich nach unserer
      Datenschutzerklärung: <Link to="/privacy">Datenschutzerklärung</Link>.
    </p>
    <p>
      <strong>17.2</strong> Informationen zu Cookies und ähnlichen Technologien finden Sie in
      unserem Cookie-Hinweis bzw. der Datenschutzerklärung:{' '}
      <Link to="/privacy">Datenschutz &amp; Cookies</Link>.
    </p>
    <p>
      <strong>17.3</strong> Diese Nutzungsbedingungen regeln nicht abschließend alle
      datenschutzrechtlichen Fragen. Maßgeblich sind insoweit die Datenschutzerklärung und das
      anwendbare Datenschutzrecht.
    </p>

    <h2>18. Kündigung durch Sie</h2>
    <p>
      <strong>18.1</strong> Sie können Ihr Konto jederzeit mit Wirkung für die Zukunft löschen
      oder die Löschung verlangen.
    </p>
    <p>
      <strong>18.2</strong> Nach einer Kündigung oder Löschung werden wir Ihr Konto deaktivieren
      oder löschen, soweit keine gesetzlichen Aufbewahrungspflichten, berechtigten
      Sicherheitsinteressen, Missbrauchsprävention oder offene Rechtsstreitigkeiten entgegenstehen.
    </p>
    <p>
      <strong>18.3</strong> Öffentliche Beiträge können – soweit technisch vorgesehen – von
      Ihnen gelöscht werden. Bereits erstellte Sicherungskopien, Protokolle oder gesetzlich
      erforderliche Aufbewahrungen bleiben unberührt.
    </p>

    <h2>19. Sperrung und Kündigung durch uns</h2>
    <p>
      <strong>19.1</strong> Wir können den Nutzungsvertrag über ein unentgeltliches Konto
      ordentlich mit einer Frist von 30 Tagen kündigen.
    </p>
    <p>
      <strong>19.2</strong> Wir können den Zugang zum Dienst ganz oder teilweise vorübergehend
      sperren oder den Nutzungsvertrag aus wichtigem Grund fristlos kündigen, wenn unter
      Berücksichtigung aller Umstände und beider Interessen die Fortsetzung des
      Vertragsverhältnisses unzumutbar ist.
    </p>
    <p>
      <strong>19.3</strong> Ein wichtiger Grund liegt insbesondere vor, wenn Sie:
    </p>
    <ul>
      <li>erheblich oder wiederholt gegen diese Nutzungsbedingungen verstoßen,</li>
      <li>rechtswidrige Inhalte einstellen,</li>
      <li>andere Personen gefährden, belästigen oder täuschen,</li>
      <li>den Dienst technisch missbrauchen,</li>
      <li>falsche Angaben in wesentlichen Punkten machen,</li>
      <li>Sicherheitsmechanismen umgehen oder</li>
      <li>gesetzliche Pflichten verletzen.</li>
    </ul>
    <p>
      <strong>19.4</strong> Soweit gesetzlich vorgesehen oder sachgerecht, warnen wir Sie vor
      einer Sperre oder Kündigung und geben Ihnen Gelegenheit zur Stellungnahme, es sei denn,
      eine sofortige Maßnahme ist zur Gefahrenabwehr, zur Erfüllung gesetzlicher Pflichten oder
      zur Verhinderung weiterer Schäden erforderlich.
    </p>
    <p>
      <strong>19.5</strong> Nach einer Sperre oder Kündigung dürfen Sie kein neues Konto
      anlegen, soweit wir Ihnen dies nicht ausdrücklich gestatten.
    </p>

    <h2>20. Haftung</h2>
    <p>
      <strong>20.1</strong> Wir haften unbeschränkt nach den gesetzlichen Vorschriften:
    </p>
    <ul>
      <li>bei Vorsatz und grober Fahrlässigkeit,</li>
      <li>bei Verletzung von Leben, Körper oder Gesundheit,</li>
      <li>nach dem Produkthaftungsrecht,</li>
      <li>bei arglistigem Verschweigen von Mängeln und</li>
      <li>in allen Fällen zwingender gesetzlicher Haftung.</li>
    </ul>
    <p>
      <strong>20.2</strong> Bei leichter Fahrlässigkeit haften wir nur bei Verletzung solcher
      Pflichten, deren Erfüllung die ordnungsgemäße Durchführung des Vertrags überhaupt erst
      ermöglicht und auf deren Einhaltung Sie regelmäßig vertrauen dürfen. In diesem Fall ist
      unsere Haftung auf den vertragstypischen, vorhersehbaren Schaden beschränkt.
    </p>
    <p>
      <strong>20.3</strong> Für Inhalte, Angaben und Handlungen von Nutzerinnen und Nutzern oder
      sonstigen Dritten haften wir nur nach den gesetzlichen Vorschriften.
    </p>
    <p>
      <strong>20.4</strong> Die vorstehenden Haftungsregelungen gelten auch zugunsten unserer
      gesetzlichen Vertreter, Mitarbeitenden und Erfüllungsgehilfen.
    </p>

    <h2>21. Änderungen dieser Nutzungsbedingungen</h2>
    <p>
      <strong>21.1</strong> Wir dürfen diese Nutzungsbedingungen ändern, wenn dafür ein sachlicher
      Grund besteht, insbesondere bei:
    </p>
    <ul>
      <li>Änderungen der Rechtslage,</li>
      <li>neuen regulatorischen Anforderungen,</li>
      <li>Sicherheits- oder Missbrauchslagen,</li>
      <li>technischen Änderungen des Dienstes oder</li>
      <li>Erweiterungen oder Umstellungen unseres Angebots.</li>
    </ul>
    <p>
      <strong>21.2</strong> Rein redaktionelle Änderungen, Klarstellungen, Anpassungen von
      Kontaktangaben oder Änderungen, die ausschließlich zugunsten der Nutzerinnen und Nutzer
      wirken, können wir mit Wirkung für die Zukunft ohne gesonderte Zustimmung vornehmen.
    </p>
    <p>
      <strong>21.3</strong> Sonstige wesentliche Änderungen teilen wir Ihnen rechtzeitig vor ihrem
      Inkrafttreten in klarer Form mit.
    </p>
    <p>
      <strong>21.4</strong> Änderungen, die für Sie wesentlich nachteilig sind, werden nur
      wirksam, wenn
    </p>
    <ul>
      <li>wir hierfür einen sachlichen Grund haben,</li>
      <li>
        wir Sie rechtzeitig über Inhalt, Zeitpunkt und Bedeutung der Änderung informieren und
      </li>
      <li>
        Sie zustimmen oder die weitere Nutzung nach einem deutlichen Hinweis als Zustimmung
        gewertet werden darf, ohne dass zwingendes Verbraucherrecht entgegensteht.
      </li>
    </ul>
    <p>
      <strong>21.5</strong> Wenn Sie mit einer wesentlichen Änderung nicht einverstanden sind,
      können Sie den Nutzungsvertrag bis zum Inkrafttreten der Änderung kostenlos kündigen.
    </p>

    <h2>22. Anwendbares Recht und Gerichtsstand</h2>
    <p>
      <strong>22.1</strong> Diese Nutzungsbedingungen und alle Streitigkeiten aus oder im
      Zusammenhang mit ihnen unterliegen österreichischem Recht unter Ausschluss seiner
      Verweisungsnormen und des UN-Kaufrechts.
    </p>
    <p>
      <strong>22.2</strong> Wenn Sie Verbraucher sind und in einem Staat wohnen, dessen
      zwingende Verbraucherschutzvorschriften Ihnen weitergehenden Schutz gewähren, bleiben diese
      zwingenden Vorschriften unberührt.
    </p>
    <p>
      <strong>22.3</strong> Für Klagen gegen Verbraucher gelten die gesetzlichen Gerichtsstände.
    </p>
    <p>
      <strong>22.4</strong> Sind Sie Unternehmer, juristische Person des öffentlichen Rechts oder
      öffentlich-rechtliches Sondervermögen, ist – soweit gesetzlich zulässig – Wien, Innere
      Stadt, ausschließlicher Gerichtsstand.
    </p>

    <h2>23. Schlussbestimmungen</h2>
    <p>
      <strong>23.1</strong> Sollten einzelne Bestimmungen dieser Nutzungsbedingungen ganz oder
      teilweise unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen
      unberührt.
    </p>
    <p>
      <strong>23.2</strong> Eine unwirksame Bestimmung wird durch die gesetzliche Regelung
      ersetzt. Gleiches gilt für unbeabsichtigte Regelungslücken.
    </p>
    <p>
      <strong>23.3</strong> Unsere Datenschutzerklärung, unser Cookie-Hinweis und gegebenenfalls
      ergänzende Community-Regeln oder besondere Leistungsbedingungen in ihrer jeweils gültigen
      Fassung ergänzen diese Nutzungsbedingungen.
    </p>

    <h2>24. Kontakt</h2>
    <p>
      Für Fragen, Meldungen, Beschwerden oder rechtliche Anliegen erreichen Sie uns unter:
    </p>
    <p>
      Event Partner Austria Verein
      <br />
      Kwizdastrasse 9/11
      <br />
      2100 Korneuburg
      <br />
      Österreich
    </p>
    <p>
      E-Mail: <Mail>contact@i-think-its-you.at</Mail>
      <br />
      DSA-Nutzerkontakt: <Mail>contact@i-think-its-you.at</Mail>
      <br />
      DSA-Behördenkontakt: <Mail>contact@i-think-its-you.at</Mail>
      <br />
      Kontaktformular: <Link to="/contact">Kontaktformular</Link>
    </p>
  </>
);
